export default "__VITE_ASSET__pKwHdBR0__"